import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";
import TabelPersen from "./TabelPersen";

/* ================= MODAL ================= */
const Modal = ({ children, onClose }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="relative w-full max-w-3xl bg-white rounded-lg shadow-lg p-6">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-black"
        >
          ✕
        </button>
        {children}
      </div>
    </div>
  );
};

/* ================= PERSEN ================= */
const Persen = ({ mapel }) => {
  const [persenData, setPersenData] = useState({
    Latihan: 0,
    PR: 0,
    Tugas: 0,
    UH: 0,
    STS: 0,
    SAS: 0,
    Praktikum: 0,
  });

  const [totalPersen, setTotalPersen] = useState(0);
  const [error, setError] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);

  /* ================= FETCH DATA ================= */
  const fetchPersen = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const userId = decoded.user.id;

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}api/persen/mapel/${mapel}/user/${userId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      setPersenData(res.data);
      hitungTotal(res.data);
      setError(null);
    } catch (err) {
      setPersenData({
        Latihan: 0,
        PR: 0,
        Tugas: 0,
        UH: 0,
        STS: 0,
        SAS: 0,
        Praktikum: 0,
      });
      hitungTotal({});
      setError(
        err.response?.status === 404
          ? "Belum ada data persen. Klik Edit untuk mengisi."
          : "Gagal mengambil data persen",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPersen();
  }, [mapel]);

  /* ================= HITUNG TOTAL ================= */
  const hitungTotal = (data) => {
    const fields = ["Latihan", "PR", "Tugas", "UH", "STS", "SAS", "Praktikum"];

    const total = fields.reduce(
      (sum, key) => sum + (Number(data[key]) || 0),
      0,
    );

    setTotalPersen(total);
  };

  /* ================= CALLBACK SETELAH UPDATE ================= */
  const handleSuccessUpdate = () => {
    setIsEditing(false); // tutup popup
    fetchPersen(); // refresh data TANPA reload
  };

  return (
    <div className="container mx-auto p-6 md:p-10 my-6">
      <h2 className="text-2xl font-bold mb-6">Persentase Penilaian</h2>

      {error && <p className="mb-4 text-red-600 font-medium">{error}</p>}

      {loading ? (
        <p className="text-gray-500">Memuat data...</p>
      ) : (
        <>
          {/* ================= VIEW MODE ================= */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {["Latihan", "PR", "Tugas", "UH", "STS", "SAS", "Praktikum"].map(
              (jenis) => (
                <div
                  key={jenis}
                  className="flex items-center gap-2 bg-gray-50 p-3 rounded-md"
                >
                  <label className="w-28 font-semibold text-gray-700">
                    {jenis}
                  </label>
                  <input
                    type="number"
                    value={persenData[jenis] || 0}
                    readOnly
                    className="border p-2 rounded-md w-full bg-white"
                  />
                  <span className="font-semibold">%</span>
                </div>
              ),
            )}

            {/* TOTAL */}
            <div className="flex items-center gap-2 bg-gray-100 p-3 rounded-md md:col-span-3">
              <label className="w-28 font-bold text-gray-800">Total</label>
              <input
                type="number"
                value={totalPersen}
                readOnly
                className={`border p-2 rounded-md w-full font-bold ${
                  totalPersen === 100 ? "text-green-600" : "text-red-600"
                }`}
              />
              <span className="font-bold">%</span>
            </div>
          </div>

          {/* ================= BUTTON EDIT ================= */}
          <div className="mt-6">
            <button
              onClick={() => setIsEditing(true)}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md shadow"
            >
              Edit Persentase
            </button>
          </div>
        </>
      )}

      {/* ================= MODAL EDIT ================= */}
      {isEditing && (
        <Modal onClose={() => setIsEditing(false)}>
          <TabelPersen
            mapel={mapel}
            initialData={persenData}
            onSubmit={handleSuccessUpdate}
            onCancel={() => setIsEditing(false)}
          />
        </Modal>
      )}
    </div>
  );
};

export default Persen;
